import { useState, useEffect, useCallback } from 'react';
import mainSocket from '~shared/services/mainSocketClass';
import { getArticles, wsHandler } from './utils';
import { useSpotlightSports } from '~SpectateStore/hooks/clientStateHooks';

const ARTICLE_TYPE = 'spotlight';

export const useIsSpotlightSportSupported = (sportSlug) => {
    const spotlightSports = useSpotlightSports();

    if (sportSlug && !spotlightSports.includes(sportSlug)) {
        return false;
    }

    return true;
};

/**
 * Sets useSpotlight
 *
 * @param {Object} spotlightParams sportSlug and eventId
 * @returns {Object} spotlight data
 */
const useSpotlight = ({
    sportSlug,
    eventId,
} = {}) => {
    const [spotlightData, setSpotlightData] = useState({});
    const isSportSupported = useIsSpotlightSportSupported(sportSlug);

    const handleWs = useCallback(wsData => wsHandler(wsData, setSpotlightData), [sportSlug, eventId]);

    useEffect(() => {
        let unsubscribeWs;
        let wsPayload;

        if (isSportSupported) {
            getArticles(sportSlug, eventId, ARTICLE_TYPE).then(data => {
                setSpotlightData(data);

                if (data?.selection_pointers) {
                    const {
                        selection_pointers: selectionPointers,
                    } = data;

                    wsPayload = [{
                        'event_id': selectionPointers.event_id,
                        'market_id': selectionPointers.market_id,
                        'selection_id': selectionPointers.selection_id,
                    }];
                    mainSocket.subscribeForUpdates(wsPayload, 'spotlight-widget');
                    unsubscribeWs = mainSocket.onWsEventUpdate(handleWs);
                }
            });
        } else {
            setSpotlightData({ error: true });
        }

        return () => {
            if (unsubscribeWs) {
                unsubscribeWs();
            }
            if (wsPayload) {
                mainSocket.unsubscribeForUpdates(wsPayload);
            }
        };
    }, [isSportSupported, sportSlug, eventId]);

    return { spotlightData };
};

export default useSpotlight;
